export default __webpack_public_path__ + "static/media/logo_sfp_light.cb07799e.png";